import type { MiniRule, MappedRules } from '../types';

export function groupMiniRules(miniRules: Array<MiniRule>) {
  return miniRules.reduce((acc: MappedRules, rule: MiniRule) => {
    if (!Object.prototype.hasOwnProperty.call(acc, rule.category)) {
      acc[rule.category] = {};
    }
    if (!Object.prototype.hasOwnProperty.call(acc[rule.category], rule.title)) {
      acc[rule.category][rule.title] = [];
    }

    acc[rule.category][rule.title].push(rule);
    return acc;
  }, {});
}
